import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Dropdown, Accordion, Modal, Button } from 'react-bootstrap'
import Card from '../../components/Card'
import { Link, useNavigate, Route } from 'react-router-dom'
import { apiHandler } from '../../api/apihandler';
import { TEACHERS_ACTIVITY_DELETE_API, TEACHERS_ACTIVITY_LIST_API, TEACHERS_ACTIVITY_PRINT_API, TEACHERS_ACTIVITY_UPDATE_API, TEACHERS_RESULTS_LIST_API, TEACHERS_RESULTS_LIST_DELETE_API, TEACHERS_RESULTS_LIST_UPDATE_API } from "../../api/constants";
import Moment from 'moment';
import ShareModal from '../../components/ai/ShareModal';
import NoDataFound from '../noDataFound';
import { InView } from "react-intersection-observer";
import loader from '../../assets/images/page-img/page-load-loader.gif'

//Sweet alert
import Swal from 'sweetalert2'

const ActivityListCardByLessonPlan = ({ refreshKey, aiSearchResultId }) => {

    const navigate = useNavigate();
    const [aiResponseList, setAiResponseList] = useState([]);
    const [showMoreDataLoader, setShowMoreDataLoader] = useState(false);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);

    const [showShareModal, setShowShareModal] = useState(false);
    const [shareModalData, setShareModalData] = useState({});
    const [classId, setClassId] = useState('');
    const handleClose = () => setShowShareModal(false);

    const [showActivityModal, setShowActivityModal] = useState(false);
    const [modalActivity, setModalActivity] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [editContent, setEditContent] = useState("");

    useEffect(() => {
        getResponseListApi();
    }, []);

    useEffect(() => {
        refreshApi()
    }, [refreshKey]);

    const loadMore = (inView) => {
        if (inView) {
            if (page < maxPage) {
                getResponseListApi(page + 1)
                setPage(page + 1)
            }
        }
    };

    function refreshApi() {
        setPage(1)
        getResponseListApi(1)
    }

    async function getResponseListApi(pageVal) {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_ACTIVITY_LIST_API, "POST", {
                page: pageVal,
                limit: 10,
                ai_search_result_id: aiSearchResultId
            })
            setMaxPage(res?.data?.data?.aiSearchResultList?.meta?.last_page)
            if (res.data?.response?.status === 200) {
                if (pageVal === 1) {
                    setAiResponseList(res?.data?.data?.lesson_plan?.ai_activities)
                } else {
                    setAiResponseList(aiResponseList.concat(res?.data?.data?.lesson_plan?.ai_activities))
                }
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    async function getDeleteResponseApi(id) {
        try {
            const res = await apiHandler(TEACHERS_ACTIVITY_DELETE_API, "DELETE", {
                id: id,
            })
            if (res.data?.response?.status === 200) {
                refreshApi()
            }
        } catch (error) {
            console.error(error);
        }
    }

    const handleShowActivityModal = (activity) => {
        setModalActivity(activity);
        setEditMode(false);
        setEditContent(activity?.content || "");
        setShowActivityModal(true);
    };
    const handleCloseActivityModal = () => {
        setShowActivityModal(false);
        setEditMode(false);
        setEditContent("");
    };
    const handleEditSave = async () => {
        try {
            const res = await apiHandler(TEACHERS_ACTIVITY_UPDATE_API, "POST", {
                id: modalActivity?.id,
                content: editContent
            });
            if (res.data?.response?.status === 200) {
                refreshApi();
                setShowActivityModal(false);
            }
        } catch (error) {
            console.error(error);
        }
    };
    const handleDelete = async () => {
        await getDeleteResponseApi(modalActivity?.lesson_plan?.id);
        setShowActivityModal(false);
    };

    async function getActivityPrintApi(id) {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_ACTIVITY_PRINT_API, "POST", {
                activity_id: id,
            })
            if (res.data?.response?.status === 200) {
                window.open(res?.data?.data?.url, '_blank');
            }
        } catch (error) {
            console.error(error);
        } finally {
            setShowMoreDataLoader(false)
        }
    }
    return (
        <>
            <Card>
                <div className="card-header d-flex justify-content-between">
                    <div className="header-title">
                        <h4 className="card-title">Activity List </h4>
                    </div>
                </div>
                <Card.Body>
                    <ul className="request-list m-0 p-0">
                        {
                            aiResponseList?.length > 0 ?
                                <div>
                                    {aiResponseList?.map((activity, activityIdx) => {
                                        const isLong = (activity?.content || "").split('\n')?.length > 4 || (activity?.content || "")?.length > 180;
                                        return (
                                            <li className="d-flex mb-3" key={activityIdx} style={{ borderBottom: "1px solid #eee", paddingBottom: 10 }}>
                                                <div style={{ width: "97%" }}>
                                                    <div className="ms-3">
                                                        <p className="mb-0 text-muted" style={{ fontSize: 13 }}>
                                                            {Moment(activity?.ai_search?.updated_at).format('MMM D YYYY')}
                                                        </p>
                                                        <div style={{ flexWrap: "wrap", display: "flex", gap: "10px", alignItems: "center" }}>
                                                            {activity?.ai_search?.topic && activity?.ai_search?.topic !== '' &&
                                                                <span className="badge bg-info ms-2">Topic: {activity?.ai_search?.topic}</span>
                                                            }
                                                            <h6 className="mb-0" style={{ fontWeight: 100, width: "100%", position: "relative" }}>
                                                                <span
                                                                    className="activity-content-truncate"
                                                                    style={{
                                                                        display: "-webkit-box",
                                                                        WebkitLineClamp: 4,
                                                                        WebkitBoxOrient: "vertical",
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "pre-line",
                                                                        cursor: "pointer"
                                                                    }}
                                                                >
                                                                    {activity?.content}
                                                                </span>
                                                                {isLong && (
                                                                    <span
                                                                        className="show-more-link"
                                                                        style={{
                                                                            color: "#1976d2",
                                                                            fontWeight: 500,
                                                                            cursor: "pointer",
                                                                            marginLeft: 8
                                                                        }}
                                                                        onClick={() => handleShowActivityModal(activity)}
                                                                    >
                                                                        Show more
                                                                    </span>
                                                                )}
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card-post-toolbar" style={{ marginLeft: 10 }}>
                                                    <Dropdown>
                                                        <Dropdown.Toggle variant="bg-transparent" style={{ cursor: "pointer", border: "none", boxShadow: "none", padding: 0 }}>
                                                            <span className="material-symbols-outlined" style={{ fontSize: 22, color: "#757575" }}>
                                                                more_vert
                                                            </span>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    setModalActivity(activity);
                                                                    setEditMode(true);
                                                                    setEditContent(activity?.content || "");
                                                                    setShowActivityModal(true);
                                                                }}
                                                            >
                                                                <i className="ri-edit-2-fill me-2"></i>Edit
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    getActivityPrintApi(activity?.id)
                                                                }}
                                                            >
                                                                <i className="ri-printer-fill me-2"></i>Print in PDF
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    await getDeleteResponseApi(activity?.id);
                                                                }}
                                                            >
                                                                <i className="ri-delete-bin-6-fill me-2"></i>Delete
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </div>
                                : <NoDataFound txtData="No results found yet!" />
                        }
                    </ul>
                </Card.Body>
            </Card>
            {
                showMoreDataLoader ?
                    <div className="col-sm-12 text-center">
                        <img src={loader} alt="loader" style={{ height: "100px" }} />
                    </div> : null
            }
            {
                showShareModal ?
                    <ShareModal handleClose={handleClose} classId={classId} data={shareModalData} />
                    : null
            }

            <Modal
                show={showActivityModal}
                onHide={handleCloseActivityModal}
                centered
                size="lg"
                dialogClassName="activity-modal-fixed"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Activity Content</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {editMode ? (
                        <textarea
                            className="form-control"
                            rows={8}
                            value={editContent}
                            onChange={e => setEditContent(e.target.value)}
                        />
                    ) : (
                        <div className="activity-modal-content-scroll">
                            {modalActivity?.content}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {editMode ? (
                        <>
                            <Button variant="success" onClick={handleEditSave}>Save</Button>
                            <Button variant="secondary" onClick={() => setEditMode(false)}>Cancel</Button>
                        </>
                    ) : (
                        <>
                            <Button variant="primary" onClick={() => setEditMode(true)}>Edit</Button>
                            <Button variant="danger" onClick={handleDelete}>Delete</Button>
                            <Button variant="secondary" onClick={handleCloseActivityModal}>Close</Button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ActivityListCardByLessonPlan